
/**
 * @Description: todo 驼峰字段转下划线 (示例：userName ==> user_name)
 * @author wcd
 * @date 2020/2/21
 */

export default {

  humpToLine(beanObj) {
    const toLine = hump => hump.replace(/([A-Z]|\d)/g, (a, l) => `_${l.toLowerCase()}`)
    let newObj = {}
    for (let k in beanObj) {
      newObj[toLine(k)] = beanObj[k]
    }

    return newObj

  },
  /**
   * @Description: todo 获取文件格式
   * @author wcd
   * @date 2020/2/21
   */
  getFileTypeName(name) {
    return name.substring(name.lastIndexOf('.') + 1, name.length)
  },
  /**
   * @Description: todo 获取文件名
   * @author wcd
   * @date 2020/2/21
   */
  getFileName(name) {
    return name.substring(name.lastIndexOf('.'), 0)
  },

  /**
   * @Description: todo 下载文件 【fileName：文件名，base64：文件编码,contentType:文件类型】
   * @author wcd
   * @date 2020/3/13
   */
  downloadFile(fileName, base64, contentType) {
    try {
      let aLink = document.createElement('a')
      let blob = this.base64ToBlob(base64, contentType)
      let evt = document.createEvent('HTMLEvents')
      //阻止冒泡行为
      evt.initEvent('click', true, true)
      aLink.download = fileName
      aLink.href = URL.createObjectURL(blob)
      // aLink.dispatchEvent(evt);
      aLink.click()
    } catch (e) {
      return console.error('文件下载失败', e)
    }

  },
  /**
   * @Description: todo base64转blob 【注意：base64必须纯净，contentType非空则必须规范】
   * @author wcd
   * @date 2020/3/13
   */
  base64ToBlob(base64, contentType) {
    try {
      // let parts = base64.split(';base64,');
      // let contentType = parts[0].split(':')[1];
      let raw = window.atob(base64)
      let rawLength = raw.length
      let uInt8Array = new Uint8Array(rawLength)
      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i)
      }
      return new Blob([uInt8Array], { type: contentType })
    } catch (e) {
      return console.error('base转blob失败', e)
    }
  },

  /**
   * @Description: todo blobToUrl
   * @author wcd
   * @date 2020/3/13
   */
  blobToUrl(blobObj) {
    try {
      return window.URL.createObjectURL(blobObj)
    } catch (e) {
      return console.error('转换失败', e)
    }
  },
  /**
   * @Description: todo file to base64
   * @author wcd
   * @date 2020/3/13
   */
  fileToBase64(file) {
    try {

      let reader = new FileReader()
      reader.readAsDataURL(file.raw)
      reader.onload = e => {
        return e.target.result
      }

    } catch (e) {
      return console.error('转换失败', e)
    }
  },

  /**
   * @Description: todo 将字符串转为 Array byte数组
   * @author wcd
   * @date 2020/3/13
   */
  stringToByte(str) {
    try {
      let bytes = new Array()
      let len, c
      len = str.length
      for (let i = 0; i < len; i++) {
        c = str.charCodeAt(i)
        if (c >= 0x010000 && c <= 0x10FFFF) {
          bytes.push(((c >> 18) & 0x07) | 0xF0)
          bytes.push(((c >> 12) & 0x3F) | 0x80)
          bytes.push(((c >> 6) & 0x3F) | 0x80)
          bytes.push((c & 0x3F) | 0x80)
        } else if (c >= 0x000800 && c <= 0x00FFFF) {
          bytes.push(((c >> 12) & 0x0F) | 0xE0)
          bytes.push(((c >> 6) & 0x3F) | 0x80)
          bytes.push((c & 0x3F) | 0x80)
        } else if (c >= 0x000080 && c <= 0x0007FF) {
          bytes.push(((c >> 6) & 0x1F) | 0xC0)
          bytes.push((c & 0x3F) | 0x80)
        } else {
          bytes.push(c & 0xFF)
        }
      }
      return bytes
    } catch (e) {
      return console.error('转换失败', e)
    }
  },

  /**
   * @Description: todo byte数组转字符串
   * @author wcd
   * @date 2020/3/13
   */
  byteToString(arr) {
    if (typeof arr === 'string') {
      return arr
    }
    let str = '',
      _arr = arr
    for (let i = 0; i < _arr.length; i++) {
      let one = _arr[i].toString(2),
        v = one.match(/^1+?(?=0)/)
      if (v && one.length == 8) {
        let bytesLength = v[0].length
        let store = _arr[i].toString(2).slice(7 - bytesLength)
        for (let st = 1; st < bytesLength; st++) {
          store += _arr[st + i].toString(2).slice(2)
        }
        str += String.fromCharCode(parseInt(store, 2))
        i += bytesLength - 1
      } else {
        str += String.fromCharCode(_arr[i])
      }
    }
    return str
  },

  /**
   * @Description: todo file to ArrayBuffer 同步版本
   * @author wcd
   * @date 2020/3/13
   */
  fileToArrayBufferSyn(file) {
    try {
      return new Promise((resolve, reject) => {
        let reader = new FileReader()
        reader.readAsArrayBuffer(file)
        reader.onload = (ev) => {
          resolve(ev.target.result)
        }
      })
    } catch (e) {
      return console.error('转换失败', e)
    }
  },

  /**
   * @Description: todo file to base64 同步版本【推荐】
   * @author wcd
   * @date 2020/3/13
   */
  fileTobase64Syn(file) {
    try {
      return new Promise((resolve, reject) => {
        let reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = (ev) => {
          resolve(ev.target.result)
        }
      })
    } catch (e) {
      return console.error('转换失败', e)
    }
  },

  /**
   * @Description: todo file to ArrayBuffer 同步版本
   * @author wcd
   * @date 2020/3/13
   */
  ArrayBufferToBlob(result) {
    try {
      return new Promise((resolve, reject) => {
        resolve(new Blob([result]))
      })
    } catch (e) {
      return console.error('转换失败', e)
    }
  },

  /**
   * @Description: todo file to blobUrl
   * @author wcd
   * @date 2020/3/13
   */
  fileToBlobUrl(file) {
    try {
      let URL = window.URL || window.webkitURL
      return URL.createObjectURL(file.raw)
    } catch (e) {
      return console.error('转换失败', e)
    }
  },

  /**
   * @Description: todo 字符串转数组，可以指定长度【str源字符串，len间隔长度，endLen末尾长度】
   * @author wcd
   * @date 2020/3/13
   */
  strToArr(str, len, endLen) {
    try {
      let arr = []
      while (true) {
        let ss = str.substring(0, len)
        if (str.length <= endLen) {
          ss = str.substring(0, str.length)
          arr.push(ss)
          str = ''
          break
        }
        // str = str.replace(new RegExp(ss), '')//不准确，字符串重复就出错
        str = str.substring(ss.length, str.length)
        arr.push(ss)
      }
      return arr
    } catch (e) {
      return console.error('转换失败', e)
    }
  },

  /**
   * @Description: todo 字符串转数组【strToArr的非循环版，数据量巨大的时候，这个配合定时器使用】
   * @author wcd
   * @date 2020/3/13
   */
  strToArrAcyclic(str, len, endLen) {
    try {
      if (str.length <= endLen) {
        return str.substring(0, str.length)
      }
      return str.substring(0, len)
    } catch (e) {
      return console.error('转换失败', e)
    }
  },

  /**
   * @Description: todo 进度值换算
   * @author wcd
   * @date 2020/3/13
   */
  progress(str, len, endLen) {
    try {
      if (str.length <= endLen) {
        return str.substring(0, str.length)
      }
      return str.substring(0, len)
    } catch (e) {
      return console.error('转换失败', e)
    }
  }
}






// WEBPACK FOOTER //
// ./src/utils/cdUtils/beanUtils.js